import { render } from "./CustomTab.vue?vue&type=template&id=4c928cad"
import script from "./CustomTab.vue?vue&type=script&lang=js"
export * from "./CustomTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__